export * from './network';

export const EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000';
export const MAX_SAFE_NUMBER = 99999999999999;
export const MIN_SAFE_NUMBER = -99999999999999;
